import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteUserDialog = ({ isOpen, user, onConfirm, onCancel, loading }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4">
      <div className="bg-card border border-border rounded-xl shadow-2xl w-full max-w-md">
        {/* Header */}
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-red-100">
              <Icon name="Trash2" size={20} className="text-red-600" />
            </div>
            <h2 className="text-xl font-semibold text-foreground">Delete User</h2>
          </div>
          <Button variant="ghost" size="icon" onClick={onCancel}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {/* User info */}
          <div className="bg-muted/50 rounded-lg p-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <Icon name="UserX" size={18} className="text-red-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{user?.full_name || 'Unnamed User'}</p>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          {/* Warning */}
          <div className="rounded-lg p-3 border bg-red-50 border-red-200 text-red-800">
            <div className="flex items-start gap-2">
              <Icon name="AlertTriangle" size={16} className="mt-0.5 flex-shrink-0" />
              <p className="text-sm">
                <strong>This action cannot be undone.</strong> The user account and all associated profile data will be permanently deleted from the system.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              className="flex-1"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={onConfirm}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white border-red-600"
              loading={loading}
              disabled={loading}
            >
              <Icon name="Trash2" size={16} className="mr-2" />
              Delete Permanently
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserDialog;
